export default __webpack_public_path__ + "static/media/logo.fd8d4538.png";